// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3bXI9","Label":"BuildControl_Label__iTfD5","Less":"BuildControl_Less__2u5qm","More":"BuildControl_More__YgHTG"};